import { Tabs, Tab, Paper } from '@mui/material';

interface AppraiseeNavigationBarProps {
  appraiseeNames: string[];
  currentIndex: number;
  onSelect: (index: number) => void;
}

export function AppraiseeNavigationBar({
  appraiseeNames,
  currentIndex,
  onSelect,
}: AppraiseeNavigationBarProps) {
  if (appraiseeNames.length === 0) {
    return null;
  }

  const safeIndex = Math.min(Math.max(0, currentIndex), appraiseeNames.length - 1);

  return (
    <Paper
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        bgcolor: 'background.paper',
        borderRadius: 1,
        mb: 3,
      }}
    >
      <Tabs
        value={safeIndex}
        onChange={(_, newValue) => onSelect(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="Appraisee navigation tabs"
      >
        {appraiseeNames.map((name, index) => (
          <Tab
            key={index}
            label={name.toUpperCase()}
            id={`appraisee-tab-${index}`}
            aria-controls={`appraisee-tabpanel-${index}`}
          />
        ))}
      </Tabs>
    </Paper>
  );
}
